import { render, staticRenderFns } from "./ForgotPasswordForm.vue?vue&type=template&id=66fd544e&scoped=true&lang=pug&"
import script from "./ForgotPasswordForm.vue?vue&type=script&lang=js&"
export * from "./ForgotPasswordForm.vue?vue&type=script&lang=js&"
import style0 from "./ForgotPasswordForm.vue?vue&type=style&index=0&id=66fd544e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66fd544e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VForm,VTextField})
